import React from "react";

// Line-art icons from the approved sidebar mockup (mym-erp-redesign-concept-sidebar.html).
// Menu entries use antd icons (as on the old top nav); this is for the
// connected-services external-link arrow.
const createNavIcon = (paths, size = 18) => {
  const NavIcon = ({ className }) => (
    <span role="img" aria-hidden="true" className={`anticon nav-svg-icon ${className || ""}`}>
      <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8">
        {paths}
      </svg>
    </span>
  );
  return NavIcon;
};

export const ExternalLinkIcon = createNavIcon(
  <path d="M7 17L17 7M9 7h8v8" strokeLinecap="round" strokeLinejoin="round" />,
  13
);
